import Services from '../components/sections/Services';

export default function ServicesPage() {
  return (
    <div className="pt-20">
      <Services />
    </div>
  );
}